import React from 'react';

import { SelectInput } from 'hosman-material';

const options = [
  { id: 1, value: 'owner', name: 'Je suis propriétaire' },
  { id: 2, value: 'primo_buyer', name: 'Je suis primo accédant' },
  { id: 3, value: 'hunter', name: 'Je suis un chasseur immobilier' },
  { id: 4, value: 'rental_investment', name: 'Je suis un investisseur locatif' },
];

const SituationSelect = ({ value, onChange, errors }) => {
  return (
    <div className='w-full'>
      <SelectInput
        name='situation'
        options={options}
        selectedOption={options.find((option) => option.value === value) || null}
        handleChange={onChange}
        label='Quelle est votre situation ?'
        errors={errors}
      />
    </div>
  );
};

export default SituationSelect;
